var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangelogBasm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.72,
    height: 23.191,
    viewBox: "0 0 36.72 23.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basm-changelog",
    transform: "translate(-16.281 -9.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10397",
    "data-name": "Group 10397",
    transform: "translate(50.393 30.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33217",
    "data-name": "Path 33217",
    d: "M873.2,541.3l-1.559.215a.036.036,0,0,0,0,.072l2.054.187Z",
    transform: "translate(-871.612 -541.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10398",
    "data-name": "Group 10398",
    transform: "translate(51.031 31.151)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1865",
    "data-name": "Ellipse 1865",
    cx: 0.076,
    cy: 0.487,
    rx: 0.076,
    ry: 0.487,
    transform: "translate(0 0.152) rotate(-88.986)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10484",
    "data-name": "Group 10484",
    transform: "translate(19.127 28.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10399",
    "data-name": "Group 10399",
    transform: "translate(0 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33218",
    "data-name": "Path 33218",
    d: "M90.41,520.5H88.065a.427.427,0,0,0-.187.028l-.239.231c-.016.016.044.028.136.028h2.389a.4.4,0,0,0,.187-.028l.2-.231C90.561,520.512,90.5,520.5,90.41,520.5Z",
    transform: "translate(-87.636 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10400",
    "data-name": "Group 10400",
    transform: "translate(2.869 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33219",
    "data-name": "Path 33219",
    d: "M161.382,520.5h-1.44a.392.392,0,0,0-.183.028h0l-.2.231c-.012.016.048.028.14.028h1.468a.381.381,0,0,0,.183-.028h0l.167-.231C161.534,520.512,161.47,520.5,161.382,520.5Z",
    transform: "translate(-159.562 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10401",
    "data-name": "Group 10401",
    transform: "translate(4.819 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33220",
    "data-name": "Path 33220",
    d: "M210.248,520.5h-1.44a.372.372,0,0,0-.179.028h0l-.164.231c-.012.016.052.028.144.028h1.468a.349.349,0,0,0,.179-.028h0l.136-.231C210.4,520.512,210.336,520.5,210.248,520.5Z",
    transform: "translate(-208.464 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10402",
    "data-name": "Group 10402",
    transform: "translate(6.766 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33221",
    "data-name": "Path 33221",
    d: "M259.035,520.5h-1.44a.34.34,0,0,0-.175.028h0l-.136.231c-.008.016.056.028.148.028H258.9a.329.329,0,0,0,.175-.028h0l.108-.231C259.19,520.512,259.122,520.5,259.035,520.5Z",
    transform: "translate(-257.283 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10403",
    "data-name": "Group 10403",
    transform: "translate(0.323 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33222",
    "data-name": "Path 33222",
    d: "M96.149,512.9a.5.5,0,0,0-.183.024l-.227.223c-.016.016.044.028.132.028h1.862a.393.393,0,0,0,.183-.028l.2-.223c.012-.016-.048-.024-.136-.024Z",
    transform: "translate(-95.735 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10404",
    "data-name": "Group 10404",
    transform: "translate(0.63 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33223",
    "data-name": "Path 33223",
    d: "M103.565,506.059h2.764a.458.458,0,0,0,.179-.024l.175-.211c.012-.012-.048-.024-.136-.024h-2.712a.491.491,0,0,0-.179.024l-.219.211C103.422,506.047,103.482,506.059,103.565,506.059Z",
    transform: "translate(-103.435 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10405",
    "data-name": "Group 10405",
    transform: "translate(0.925 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33224",
    "data-name": "Path 33224",
    d: "M110.965,499.051h2.245a.448.448,0,0,0,.175-.024l.175-.2c.012-.012-.048-.024-.132-.024h-2.205a.448.448,0,0,0-.175.024l-.211.2C110.822,499.039,110.882,499.051,110.965,499.051Z",
    transform: "translate(-110.835 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10406",
    "data-name": "Group 10406",
    transform: "translate(2.661 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33225",
    "data-name": "Path 33225",
    d: "M154.734,512.9a.458.458,0,0,0-.179.024l-.191.223c-.012.016.048.028.136.028h1.436a.372.372,0,0,0,.179-.028l.167-.223c.012-.016-.052-.024-.14-.024Z",
    transform: "translate(-154.362 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10407",
    "data-name": "Group 10407",
    transform: "translate(4.57 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33226",
    "data-name": "Path 33226",
    d: "M202.374,513.175h1.436a.341.341,0,0,0,.175-.028l.14-.223c.008-.016-.056-.024-.14-.024h-1.408a.418.418,0,0,0-.175.024l-.164.223C202.222,513.163,202.282,513.175,202.374,513.175Z",
    transform: "translate(-202.236 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10408",
    "data-name": "Group 10408",
    transform: "translate(3.854 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33227",
    "data-name": "Path 33227",
    d: "M185.978,506.035l.148-.211c.008-.012-.052-.024-.136-.024h-1.38a.448.448,0,0,0-.175.024l-.171.211c-.012.016.048.024.136.024h1.408A.407.407,0,0,0,185.978,506.035Z",
    transform: "translate(-184.262 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10409",
    "data-name": "Group 10409",
    transform: "translate(5.721 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33228",
    "data-name": "Path 33228",
    d: "M232.8,506.035l.12-.211c.008-.012-.056-.024-.14-.024H231.4a.423.423,0,0,0-.172.024l-.144.211c-.008.016.052.024.14.024h1.408A.392.392,0,0,0,232.8,506.035Z",
    transform: "translate(-231.082 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10410",
    "data-name": "Group 10410",
    transform: "translate(3.626 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33229",
    "data-name": "Path 33229",
    d: "M178.695,499.051h1.38a.408.408,0,0,0,.171-.024l.148-.2c.008-.012-.052-.024-.136-.024h-1.352a.422.422,0,0,0-.171.024l-.171.2C178.551,499.039,178.611,499.051,178.695,499.051Z",
    transform: "translate(-178.562 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10411",
    "data-name": "Group 10411",
    transform: "translate(5.458 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33230",
    "data-name": "Path 33230",
    d: "M224.626,498.824l-.144.2c-.008.012.052.024.136.024H226a.384.384,0,0,0,.167-.024l.12-.2c.008-.012-.052-.024-.136-.024H224.8A.36.36,0,0,0,224.626,498.824Z",
    transform: "translate(-224.482 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10412",
    "data-name": "Group 10412",
    transform: "translate(1.209 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33231",
    "data-name": "Path 33231",
    d: "M118.089,492.343h1.352a.423.423,0,0,0,.171-.024l.179-.2c.012-.012-.044-.024-.128-.024h-1.328a.436.436,0,0,0-.171.024l-.2.2C117.949,492.331,118.005,492.343,118.089,492.343Z",
    transform: "translate(-117.96 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413",
    transform: "translate(3.008 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33232",
    "data-name": "Path 33232",
    d: "M164.71,492.319l.156-.2c.008-.012-.048-.024-.132-.024h-1.328a.411.411,0,0,0-.167.024l-.175.2c-.012.012.048.024.128.024h1.352A.384.384,0,0,0,164.71,492.319Z",
    transform: "translate(-163.062 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10414",
    "data-name": "Group 10414",
    transform: "translate(4.799 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33233",
    "data-name": "Path 33233",
    d: "M209.61,492.1h-1.328a.411.411,0,0,0-.167.024l-.152.2c-.012.012.048.024.132.024h1.352a.384.384,0,0,0,.168-.024l.128-.2C209.754,492.108,209.694,492.1,209.61,492.1Z",
    transform: "translate(-207.962 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10415",
    "data-name": "Group 10415",
    transform: "translate(6.598 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33234",
    "data-name": "Path 33234",
    d: "M254.7,492.1h-1.328a.373.373,0,0,0-.163.024l-.128.2c-.008.012.052.024.136.024h1.352a.36.36,0,0,0,.164-.024l.1-.2C254.842,492.108,254.782,492.1,254.7,492.1Z",
    transform: "translate(-253.082 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10416",
    "data-name": "Group 10416",
    transform: "translate(1.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33235",
    "data-name": "Path 33235",
    d: "M124.958,487.66h2.209a.413.413,0,0,0,.168-.024l.092-.112c.012-.012-.048-.024-.128-.024h-2.182a.414.414,0,0,0-.167.024l-.116.112C124.819,487.652,124.874,487.66,124.958,487.66Z",
    transform: "translate(-124.832 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10417",
    "data-name": "Group 10417",
    transform: "translate(4.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33236",
    "data-name": "Path 33236",
    d: "M191.261,487.66h1.384a.374.374,0,0,0,.164-.024l.08-.112c.008-.012-.048-.024-.132-.024h-1.364a.375.375,0,0,0-.164.024l-.092.112C191.122,487.652,191.182,487.66,191.261,487.66Z",
    transform: "translate(-191.135 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10418",
    "data-name": "Group 10418",
    transform: "translate(5.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33237",
    "data-name": "Path 33237",
    d: "M236.795,487.66h1.38a.338.338,0,0,0,.16-.024l.064-.112c.008-.012-.052-.024-.132-.024H236.9a.389.389,0,0,0-.164.024l-.076.112C236.651,487.652,236.711,487.66,236.795,487.66Z",
    transform: "translate(-236.662 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10419",
    "data-name": "Group 10419",
    transform: "translate(6.475 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33238",
    "data-name": "Path 33238",
    d: "M250.127,513.175h1.436c.088,0,.168-.012.171-.028l.108-.223c.008-.016-.056-.024-.144-.024h-1.408a.393.393,0,0,0-.171.024l-.136.223C249.976,513.163,250.04,513.175,250.127,513.175Z",
    transform: "translate(-249.983 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10420",
    "data-name": "Group 10420",
    transform: "translate(8.381 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33239",
    "data-name": "Path 33239",
    d: "M297.932,513.175h1.436a.321.321,0,0,0,.171-.028l.08-.223c0-.016-.06-.024-.148-.024h-1.408a.393.393,0,0,0-.171.024l-.108.223C297.777,513.163,297.844,513.175,297.932,513.175Z",
    transform: "translate(-297.784 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10421",
    "data-name": "Group 10421",
    transform: "translate(7.591 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33240",
    "data-name": "Path 33240",
    d: "M279.7,506.035l.092-.211c0-.012-.06-.024-.144-.024h-1.38a.384.384,0,0,0-.168.024l-.116.211c-.008.016.056.024.144.024h1.408A.346.346,0,0,0,279.7,506.035Z",
    transform: "translate(-277.983 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10422",
    "data-name": "Group 10422",
    transform: "translate(9.462 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33241",
    "data-name": "Path 33241",
    d: "M326.611,506.035l.064-.211c0-.012-.06-.024-.148-.024h-1.38a.347.347,0,0,0-.164.024l-.088.211c0,.016.06.024.148.024h1.408A.337.337,0,0,0,326.611,506.035Z",
    transform: "translate(-324.896 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10423",
    "data-name": "Group 10423",
    transform: "translate(7.288 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33242",
    "data-name": "Path 33242",
    d: "M270.5,498.824l-.12.2c-.008.012.056.024.14.024h1.38a.347.347,0,0,0,.163-.024l.1-.2c.008-.012-.056-.024-.14-.024h-1.352C270.583,498.8,270.511,498.808,270.5,498.824Z",
    transform: "translate(-270.383 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10424",
    "data-name": "Group 10424",
    transform: "translate(9.123 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33243",
    "data-name": "Path 33243",
    d: "M316.476,498.824l-.092.2c-.008.012.056.024.144.024h1.38a.36.36,0,0,0,.164-.024l.068-.2c0-.012-.06-.024-.144-.024h-1.352C316.551,498.8,316.48,498.808,316.476,498.824Z",
    transform: "translate(-316.383 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10425",
    "data-name": "Group 10425",
    transform: "translate(10.288 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33244",
    "data-name": "Path 33244",
    d: "M345.748,513.175h1.436c.088,0,.164-.012.167-.028l.052-.223c0-.016-.064-.024-.152-.024h-1.408a.37.37,0,0,0-.167.024l-.08.223C345.592,513.163,345.66,513.175,345.748,513.175Z",
    transform: "translate(-345.596 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10426",
    "data-name": "Group 10426",
    transform: "translate(12.198 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33245",
    "data-name": "Path 33245",
    d: "M393.648,513.175h1.436c.088,0,.16-.012.164-.028l.024-.223c0-.016-.068-.024-.156-.024h-1.408a.334.334,0,0,0-.164.024l-.048.223C393.492,513.163,393.56,513.175,393.648,513.175Z",
    transform: "translate(-393.496 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427",
    transform: "translate(11.329 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33246",
    "data-name": "Path 33246",
    d: "M373.411,506.035l.036-.211c0-.012-.064-.024-.152-.024h-1.38a.325.325,0,0,0-.159.024l-.06.211c0,.016.064.024.148.024h1.408C373.339,506.059,373.411,506.047,373.411,506.035Z",
    transform: "translate(-371.696 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10428",
    "data-name": "Group 10428",
    transform: "translate(13.199 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33247",
    "data-name": "Path 33247",
    d: "M420.311,506.035l.008-.211c0-.012-.068-.024-.152-.024h-1.38a.325.325,0,0,0-.16.024l-.032.211c0,.016.068.024.152.024h1.408C420.239,506.059,420.311,506.047,420.311,506.035Z",
    transform: "translate(-418.596 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10429",
    "data-name": "Group 10429",
    transform: "translate(10.954 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33248",
    "data-name": "Path 33248",
    d: "M362.36,498.824l-.064.2c0,.012.06.024.148.024h1.38a.325.325,0,0,0,.16-.024l.04-.2c0-.012-.064-.024-.148-.024h-1.352C362.435,498.8,362.364,498.808,362.36,498.824Z",
    transform: "translate(-362.296 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10430",
    "data-name": "Group 10430",
    transform: "translate(12.784 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33249",
    "data-name": "Path 33249",
    d: "M408.236,498.824l-.04.2c0,.012.064.024.148.024h1.38c.084,0,.156-.012.156-.024l.016-.2c0-.012-.068-.024-.148-.024H408.4C408.308,498.8,408.236,498.808,408.236,498.824Z",
    transform: "translate(-408.196 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10431",
    "data-name": "Group 10431",
    transform: "translate(8.397 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33250",
    "data-name": "Path 33250",
    d: "M299.771,492.1h-1.328a.35.35,0,0,0-.16.024l-.1.2c-.008.012.056.024.14.024h1.352a.325.325,0,0,0,.16-.024l.076-.2C299.915,492.108,299.851,492.1,299.771,492.1Z",
    transform: "translate(-298.183 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10432",
    "data-name": "Group 10432",
    transform: "translate(10.192 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33251",
    "data-name": "Path 33251",
    d: "M344.755,492.1h-1.328a.315.315,0,0,0-.156.024l-.076.2c0,.012.06.024.144.024h1.352a.3.3,0,0,0,.156-.024l.052-.2C344.9,492.108,344.835,492.1,344.755,492.1Z",
    transform: "translate(-343.196 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10433",
    "data-name": "Group 10433",
    transform: "translate(11.987 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33252",
    "data-name": "Path 33252",
    d: "M389.727,492.1H388.4a.315.315,0,0,0-.156.024l-.048.2c0,.012.06.024.144.024h1.352a.3.3,0,0,0,.156-.024l.024-.2C389.875,492.108,389.807,492.1,389.727,492.1Z",
    transform: "translate(-388.196 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10434",
    "data-name": "Group 10434",
    transform: "translate(13.782 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33253",
    "data-name": "Path 33253",
    d: "M434.7,492.1h-1.328a.3.3,0,0,0-.152.024l-.024.2c0,.012.064.024.148.024H434.7c.084,0,.152-.012.152-.024v-.2C434.851,492.108,434.783,492.1,434.7,492.1Z",
    transform: "translate(-433.2 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10435",
    "data-name": "Group 10435",
    transform: "translate(7.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33254",
    "data-name": "Path 33254",
    d: "M282.331,487.66h1.38a.351.351,0,0,0,.16-.024l.048-.112c0-.012-.056-.024-.136-.024h-1.364a.352.352,0,0,0-.16.024l-.064.112C282.192,487.652,282.251,487.66,282.331,487.66Z",
    transform: "translate(-282.195 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10436",
    "data-name": "Group 10436",
    transform: "translate(9.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33255",
    "data-name": "Path 33255",
    d: "M328.018,487.66h1.38a.316.316,0,0,0,.156-.024l.036-.112c0-.012-.06-.024-.14-.024h-1.364a.317.317,0,0,0-.156.024l-.048.112C327.875,487.652,327.935,487.66,328.018,487.66Z",
    transform: "translate(-327.882 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10437",
    "data-name": "Group 10437",
    transform: "translate(11.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33256",
    "data-name": "Path 33256",
    d: "M373.535,487.66h1.38c.08,0,.151-.012.151-.024l.02-.112c0-.012-.06-.024-.144-.024h-1.364a.3.3,0,0,0-.152.024l-.032.112C373.392,487.652,373.456,487.66,373.535,487.66Z",
    transform: "translate(-373.396 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10438",
    "data-name": "Group 10438",
    transform: "translate(13.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33257",
    "data-name": "Path 33257",
    d: "M419.048,487.66h1.38c.08,0,.148-.012.148-.024l0-.112c0-.012-.064-.024-.144-.024h-1.364a.3.3,0,0,0-.152.024l-.02.112C418.9,487.652,418.964,487.66,419.048,487.66Z",
    transform: "translate(-418.9 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10439",
    "data-name": "Group 10439",
    transform: "translate(8.716 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33258",
    "data-name": "Path 33258",
    d: "M315.557,520.5h-9.1c-.088,0-.167.012-.171.028l-.1.231c-.008.016.06.028.152.028h9.272c.092,0,.16-.012.16-.028l-.044-.231C315.72,520.512,315.644,520.5,315.557,520.5Z",
    transform: "translate(-306.184 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10440",
    "data-name": "Group 10440",
    transform: "translate(18.408 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33259",
    "data-name": "Path 33259",
    d: "M550.8,520.5h-1.44c-.088,0-.156.012-.156.028h0l.048.231c0,.016.08.028.167.028h1.468c.092,0,.159-.012.156-.028h0l-.076-.231C550.959,520.512,550.883,520.5,550.8,520.5Z",
    transform: "translate(-549.2 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10441",
    "data-name": "Group 10441",
    transform: "translate(20.326 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33260",
    "data-name": "Path 33260",
    d: "M598.887,520.5h-1.44c-.088,0-.156.012-.151.028h0l.076.231c0,.016.084.028.171.028h1.468c.092,0,.155-.012.152-.028h0l-.1-.231C599.055,520.512,598.975,520.5,598.887,520.5Z",
    transform: "translate(-597.296 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10442",
    "data-name": "Group 10442",
    transform: "translate(22.244 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33261",
    "data-name": "Path 33261",
    d: "M647.877,520.5h-2.345c-.088,0-.156.012-.148.028l.108.231a.34.34,0,0,0,.175.028h2.389c.092,0,.156-.012.144-.028l-.148-.231A.329.329,0,0,0,647.877,520.5Z",
    transform: "translate(-645.384 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10443",
    "data-name": "Group 10443",
    transform: "translate(25.071 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33262",
    "data-name": "Path 33262",
    d: "M717.867,520.5h-1.44c-.088,0-.151.012-.143.028h0l.152.231a.36.36,0,0,0,.179.028h1.468c.092,0,.151-.012.14-.028h0l-.18-.231A.34.34,0,0,0,717.867,520.5Z",
    transform: "translate(-716.283 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10444",
    "data-name": "Group 10444",
    transform: "translate(26.989 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33263",
    "data-name": "Path 33263",
    d: "M765.945,520.5H764.5c-.088,0-.152.012-.14.028h0l.179.231a.393.393,0,0,0,.183.028H766.2c.092,0,.152-.012.14-.028h0l-.207-.231A.405.405,0,0,0,765.945,520.5Z",
    transform: "translate(-764.364 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10445",
    "data-name": "Group 10445",
    transform: "translate(28.907 1.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33264",
    "data-name": "Path 33264",
    d: "M814.039,520.5H812.6c-.088,0-.148.012-.136.028h0l.211.231a.414.414,0,0,0,.187.028h1.468c.092,0,.151-.012.136-.028h0l-.239-.231A.426.426,0,0,0,814.039,520.5Z",
    transform: "translate(-812.462 -520.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10446",
    "data-name": "Group 10446",
    transform: "translate(14.101 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33265",
    "data-name": "Path 33265",
    d: "M441.36,513.175H442.8c.088,0,.16-.012.16-.028l-.008-.223c0-.016-.072-.024-.159-.024H441.38c-.088,0-.16.012-.16.024l-.02.223C441.2,513.163,441.272,513.175,441.36,513.175Z",
    transform: "translate(-441.2 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10447",
    "data-name": "Group 10447",
    transform: "translate(16.007 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33266",
    "data-name": "Path 33266",
    d: "M489.168,513.175H490.6c.088,0,.16-.012.156-.028l-.036-.223c0-.016-.076-.024-.159-.024h-1.408c-.088,0-.156.012-.156.024l.008.223C489,513.163,489.076,513.175,489.168,513.175Z",
    transform: "translate(-489 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10448",
    "data-name": "Group 10448",
    transform: "translate(15.07 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33267",
    "data-name": "Path 33267",
    d: "M467.215,506.035l-.02-.211c0-.012-.072-.024-.156-.024h-1.38c-.084,0-.156.012-.156.024l0,.211c0,.016.068.024.156.024h1.408C467.147,506.059,467.215,506.047,467.215,506.035Z",
    transform: "translate(-465.5 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10449",
    "data-name": "Group 10449",
    transform: "translate(16.912 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33268",
    "data-name": "Path 33268",
    d: "M513.439,506.035l-.048-.211a.325.325,0,0,0-.16-.024h-1.38c-.084,0-.151.012-.151.024l.02.211c0,.016.072.024.16.024h1.408C513.375,506.059,513.443,506.047,513.439,506.035Z",
    transform: "translate(-511.7 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10450",
    "data-name": "Group 10450",
    transform: "translate(14.615 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33269",
    "data-name": "Path 33269",
    d: "M454.112,498.824l-.012.2c0,.012.068.024.152.024h1.38c.084,0,.152-.012.152-.024l-.012-.2c0-.012-.068-.024-.152-.024h-1.352C454.184,498.8,454.112,498.808,454.112,498.824Z",
    transform: "translate(-454.1 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10451",
    "data-name": "Group 10451",
    transform: "translate(16.434 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33270",
    "data-name": "Path 33270",
    d: "M499.7,498.824l.016.2c0,.012.072.024.156.024h1.38c.084,0,.152-.012.148-.024l-.04-.2a.3.3,0,0,0-.156-.024h-1.352C499.764,498.8,499.7,498.808,499.7,498.824Z",
    transform: "translate(-499.7 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10452",
    "data-name": "Group 10452",
    transform: "translate(20.593 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33271",
    "data-name": "Path 33271",
    d: "M605.779,506.035l-.1-.211a.37.37,0,0,0-.168-.024h-1.38c-.084,0-.151.012-.144.024l.076.211c0,.016.08.024.167.024h1.408C605.724,506.059,605.787,506.047,605.779,506.035Z",
    transform: "translate(-603.984 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10453",
    "data-name": "Group 10453",
    transform: "translate(17.885 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33272",
    "data-name": "Path 33272",
    d: "M536.3,513.175h1.436c.088,0,.156-.012.152-.028l-.064-.223c0-.016-.076-.024-.164-.024h-1.408c-.088,0-.156.012-.151.024l.036.223C536.132,513.163,536.208,513.175,536.3,513.175Z",
    transform: "translate(-536.096 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10454",
    "data-name": "Group 10454",
    transform: "translate(19.763 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33273",
    "data-name": "Path 33273",
    d: "M583.416,513.175h1.436c.088,0,.156-.012.148-.028l-.092-.223c0-.016-.08-.024-.168-.024h-1.408c-.088,0-.156.012-.148.024l.068.223C583.252,513.163,583.328,513.175,583.416,513.175Z",
    transform: "translate(-583.184 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10455",
    "data-name": "Group 10455",
    transform: "translate(18.755 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33274",
    "data-name": "Path 33274",
    d: "M559.663,506.035l-.076-.211a.334.334,0,0,0-.164-.024h-1.38c-.084,0-.151.012-.148.024l.048.211c0,.016.076.024.164.024h1.408C559.6,506.059,559.667,506.047,559.663,506.035Z",
    transform: "translate(-557.896 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10456",
    "data-name": "Group 10456",
    transform: "translate(18.236 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33275",
    "data-name": "Path 33275",
    d: "M544.9,498.824l.04.2a.313.313,0,0,0,.159.024h1.38c.084,0,.152-.012.147-.024l-.064-.2a.325.325,0,0,0-.16-.024h-1.352C544.964,498.8,544.9,498.808,544.9,498.824Z",
    transform: "translate(-544.9 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10457",
    "data-name": "Group 10457",
    transform: "translate(20.043 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33276",
    "data-name": "Path 33276",
    d: "M590.2,498.824l.068.2a.334.334,0,0,0,.163.024h1.38c.084,0,.148-.012.144-.024l-.092-.2a.348.348,0,0,0-.164-.024h-1.352C590.256,498.8,590.192,498.808,590.2,498.824Z",
    transform: "translate(-590.196 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10458",
    "data-name": "Group 10458",
    transform: "translate(15.576 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33277",
    "data-name": "Path 33277",
    d: "M479.676,492.1h-1.328c-.08,0-.148.012-.148.024v.2c0,.012.068.024.152.024H479.7c.084,0,.148-.012.148-.024l-.024-.2C479.823,492.108,479.755,492.1,479.676,492.1Z",
    transform: "translate(-478.2 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10459",
    "data-name": "Group 10459",
    transform: "translate(17.347 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33278",
    "data-name": "Path 33278",
    d: "M524.068,492.1H522.74c-.08,0-.148.012-.144.024l.028.2c0,.012.072.024.156.024h1.348c.084,0,.148-.012.144-.024l-.052-.2C524.219,492.108,524.151,492.1,524.068,492.1Z",
    transform: "translate(-522.596 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10460",
    "data-name": "Group 10460",
    transform: "translate(19.114 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33279",
    "data-name": "Path 33279",
    d: "M568.372,492.1h-1.328c-.08,0-.144.012-.144.024l.052.2a.317.317,0,0,0,.156.024h1.352c.084,0,.148-.012.14-.024l-.076-.2C568.523,492.108,568.455,492.1,568.372,492.1Z",
    transform: "translate(-566.9 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10461",
    "data-name": "Group 10461",
    transform: "translate(20.884 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33280",
    "data-name": "Path 33280",
    d: "M612.763,492.1h-1.328c-.08,0-.144.012-.14.024l.08.2a.325.325,0,0,0,.159.024h1.352c.084,0,.144-.012.14-.024l-.1-.2C612.919,492.108,612.847,492.1,612.763,492.1Z",
    transform: "translate(-611.296 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10462",
    "data-name": "Group 10462",
    transform: "translate(15.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33281",
    "data-name": "Path 33281",
    d: "M464.648,487.66h1.38c.08,0,.148-.012.148-.024l-.012-.112c0-.012-.068-.024-.148-.024h-1.364c-.08,0-.148.012-.148.024l0,.112C464.5,487.652,464.568,487.66,464.648,487.66Z",
    transform: "translate(-464.5 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10463",
    "data-name": "Group 10463",
    transform: "translate(16.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33282",
    "data-name": "Path 33282",
    d: "M510.06,487.66h1.38c.08,0,.144-.012.144-.024l-.024-.112a.3.3,0,0,0-.152-.024h-1.364c-.08,0-.144.012-.144.024l.012.112C509.908,487.652,509.976,487.66,510.06,487.66Z",
    transform: "translate(-509.9 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10464",
    "data-name": "Group 10464",
    transform: "translate(18.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33283",
    "data-name": "Path 33283",
    d: "M555.175,487.66h1.38c.08,0,.144-.012.14-.024l-.04-.112a.3.3,0,0,0-.156-.024h-1.364c-.08,0-.144.012-.14.024l.028.112C555.024,487.652,555.1,487.66,555.175,487.66Z",
    transform: "translate(-554.996 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465",
    transform: "translate(20.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33284",
    "data-name": "Path 33284",
    d: "M600.4,487.66h1.38c.08,0,.144-.012.136-.024l-.056-.112a.33.33,0,0,0-.156-.024h-1.364c-.08,0-.144.012-.14.024l.04.112C600.244,487.652,600.311,487.66,600.4,487.66Z",
    transform: "translate(-600.196 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10466",
    "data-name": "Group 10466",
    transform: "translate(24.278 0.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33285",
    "data-name": "Path 33285",
    d: "M696.383,505.724l.132.211a.349.349,0,0,0,.171.024h1.408c.088,0,.148-.012.14-.024l-.16-.211a.422.422,0,0,0-.171-.024h-1.38C696.435,505.7,696.375,505.712,696.383,505.724Z",
    transform: "translate(-696.382 -505.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467",
    transform: "translate(21.638 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33286",
    "data-name": "Path 33286",
    d: "M630.463,513.175H631.9c.088,0,.151-.012.144-.028l-.12-.223a.338.338,0,0,0-.172-.024h-1.408c-.088,0-.152.012-.148.024l.1.223A.321.321,0,0,0,630.463,513.175Z",
    transform: "translate(-630.196 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10468",
    "data-name": "Group 10468",
    transform: "translate(23.516 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33287",
    "data-name": "Path 33287",
    d: "M680.191,512.9h-2.764c-.088,0-.152.012-.144.024l.124.223a.341.341,0,0,0,.176.028h2.82c.088,0,.152-.012.14-.028l-.172-.223A.458.458,0,0,0,680.191,512.9Z",
    transform: "translate(-677.283 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10469",
    "data-name": "Group 10469",
    transform: "translate(22.436 0.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33288",
    "data-name": "Path 33288",
    d: "M652.018,506.035l-.132-.211a.384.384,0,0,0-.168-.024h-1.38c-.084,0-.148.012-.144.024l.1.211c.008.016.084.024.168.024h1.408C651.963,506.059,652.026,506.047,652.018,506.035Z",
    transform: "translate(-650.196 -505.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10470",
    "data-name": "Group 10470",
    transform: "translate(21.849 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33289",
    "data-name": "Path 33289",
    d: "M635.484,498.824l.1.2a.361.361,0,0,0,.164.024h1.38c.084,0,.148-.012.14-.024l-.12-.2a.36.36,0,0,0-.163-.024h-1.356C635.54,498.8,635.476,498.808,635.484,498.824Z",
    transform: "translate(-635.483 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10471",
    "data-name": "Group 10471",
    transform: "translate(23.655 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33290",
    "data-name": "Path 33290",
    d: "M682.27,498.8h-1.352c-.084,0-.144.012-.136.024l.12.2a.383.383,0,0,0,.167.024h1.38c.084,0,.148-.012.136-.024l-.144-.2A.36.36,0,0,0,682.27,498.8Z",
    transform: "translate(-680.782 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10472",
    "data-name": "Group 10472",
    transform: "translate(26.749 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33291",
    "data-name": "Path 33291",
    d: "M759.911,512.9H758.5c-.088,0-.148.012-.136.024h0l.172.223a.372.372,0,0,0,.179.028h1.436c.088,0,.148-.012.136-.028h0l-.2-.223A.417.417,0,0,0,759.911,512.9Z",
    transform: "translate(-758.362 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10473",
    "data-name": "Group 10473",
    transform: "translate(28.631 1.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33292",
    "data-name": "Path 33292",
    d: "M807.081,512.9H805.67c-.088,0-.148.012-.132.024h0l.2.223a.393.393,0,0,0,.183.028h1.436c.088,0,.148-.012.132-.028h0l-.227-.223A.518.518,0,0,0,807.081,512.9Z",
    transform: "translate(-805.535 -512.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10474",
    "data-name": "Group 10474",
    transform: "translate(28.369 0.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33293",
    "data-name": "Path 33293",
    d: "M800.475,505.7H799.1c-.084,0-.144.012-.132.024h0l.2.211a.391.391,0,0,0,.18.024h1.408c.088,0,.144-.012.132-.024h0l-.219-.211A.536.536,0,0,0,800.475,505.7Z",
    transform: "translate(-798.962 -505.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10475",
    "data-name": "Group 10475",
    transform: "translate(28.113 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33294",
    "data-name": "Path 33294",
    d: "M794.045,498.8h-1.356c-.084,0-.14.012-.128.024h0l.187.2a.448.448,0,0,0,.176.024h1.38c.084,0,.144-.012.128-.024h0l-.211-.2A.393.393,0,0,0,794.045,498.8Z",
    transform: "translate(-792.56 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10476",
    "data-name": "Group 10476",
    transform: "translate(25.454 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33295",
    "data-name": "Path 33295",
    d: "M728.224,498.8h-2.205c-.084,0-.144.012-.136.024l.148.2a.408.408,0,0,0,.172.024h.239a.16.16,0,0,1,.08.012l.188.251a.37.37,0,0,0,.176.024h1.823c.088,0,.148-.012.136-.024l-.443-.491A.393.393,0,0,0,728.224,498.8Z",
    transform: "translate(-725.882 -498.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10477",
    "data-name": "Group 10477",
    transform: "translate(27.652 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33296",
    "data-name": "Path 33296",
    d: "M782.473,487.6h-1.364c-.08,0-.136.012-.128.024l.1.112a.413.413,0,0,0,.167.024h1.38c.08,0,.136-.012.124-.024l-.116-.112A.347.347,0,0,0,782.473,487.6Z",
    transform: "translate(-780.981 -487.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10478",
    "data-name": "Group 10478",
    transform: "translate(22.655 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33297",
    "data-name": "Path 33297",
    d: "M655.7,492.124l.1.2a.36.36,0,0,0,.164.024h1.352c.084,0,.143-.012.136-.024l-.128-.2a.359.359,0,0,0-.163-.024h-1.328C655.751,492.1,655.692,492.108,655.7,492.124Z",
    transform: "translate(-655.695 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10479",
    "data-name": "Group 10479",
    transform: "translate(24.425 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33298",
    "data-name": "Path 33298",
    d: "M700.214,492.1c-.08,0-.14.012-.132.024l.128.2a.383.383,0,0,0,.167.024h3.055c.084,0,.14-.012.128-.024l-.176-.2a.411.411,0,0,0-.167-.024Z",
    transform: "translate(-700.082 -492.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10480",
    "data-name": "Group 10480",
    transform: "translate(22.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33299",
    "data-name": "Path 33299",
    d: "M645.611,487.66h1.38c.08,0,.14-.012.132-.024l-.068-.112a.352.352,0,0,0-.159-.024h-1.364c-.08,0-.14.012-.136.024l.056.112C645.459,487.652,645.531,487.66,645.611,487.66Z",
    transform: "translate(-645.395 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10481",
    "data-name": "Group 10481",
    transform: "translate(24.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33300",
    "data-name": "Path 33300",
    d: "M690.914,487.66h1.38c.08,0,.14-.012.132-.024l-.084-.112a.375.375,0,0,0-.164-.024h-1.364c-.08,0-.14.012-.132.024l.072.112C690.759,487.652,690.83,487.66,690.914,487.66Z",
    transform: "translate(-690.682 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10482",
    "data-name": "Group 10482",
    transform: "translate(25.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33301",
    "data-name": "Path 33301",
    d: "M736.015,487.66h1.38c.08,0,.14-.012.128-.024l-.1-.112a.4.4,0,0,0-.167-.024h-1.364c-.08,0-.14.012-.128.024l.084.112A.351.351,0,0,0,736.015,487.66Z",
    transform: "translate(-735.762 -487.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10483",
    "data-name": "Group 10483",
    transform: "translate(27.87 0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33302",
    "data-name": "Path 33302",
    d: "M787.919,492.1h-1.328c-.08,0-.14.012-.128.024h0l.179.2a.423.423,0,0,0,.172.024h1.352c.084,0,.14-.012.128-.024h0l-.2-.2A.382.382,0,0,0,787.919,492.1Z",
    transform: "translate(-786.462 -492.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10485",
    "data-name": "Group 10485",
    transform: "translate(16.281 9.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33303",
    "data-name": "Path 33303",
    d: "M331.043,535.8h-1.037a.038.038,0,0,0-.036.024l-.056.128a.037.037,0,0,0,.036.052h1.065a.038.038,0,0,0,.036-.028l.028-.128A.037.037,0,0,0,331.043,535.8Z",
    transform: "translate(-317.403 -514.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33304",
    "data-name": "Path 33304",
    d: "M53,32.03a.12.12,0,0,0-.04-.1l-.387-.367h0l-.259-.247c-.012-.171-.211-.235-.259-.247l-.279-.267h0L49.36,28.5s0,0-.008,0V10.57a.77.77,0,0,0-.77-.77H20.653a.77.77,0,0,0-.77.77V28.5l-3.561,3.418a.12.12,0,0,0-.04.1h0V32.4a.135.135,0,0,0,.14.136h.008a7.335,7.335,0,0,0,2.712.451h31a7.377,7.377,0,0,0,2.712-.451h.012A.134.134,0,0,0,53,32.4l0-.375Zm-2.572-.818,1.46-.2.471.447-1.926-.175A.036.036,0,0,1,50.429,31.212ZM22.994,28.58ZM48.734,10.5V27.124H20.446V10.5Zm-14.888-.251a.064.064,0,1,1,.064.064A.063.063,0,0,1,33.846,10.251Zm.662,0a.128.128,0,1,1,.255,0,.131.131,0,0,1-.128.128A.126.126,0,0,1,34.508,10.251ZM46.261,28.58h0a.088.088,0,0,1-.012.02A.088.088,0,0,0,46.261,28.58ZM20,10.57a.65.65,0,0,1,.65-.65H48.582a.65.65,0,0,1,.65.65V28.46h-3l-.06-.215s0-.008-.008-.012h0s-.008-.008-.012-.008h2.409a.589.589,0,0,0,.59-.59V10.6a.589.589,0,0,0-.59-.59H20.673a.589.589,0,0,0-.59.59V27.635a.589.589,0,0,0,.59.59h2.433s-.008,0-.012.008h0s-.008.008-.008.012l-.064.215H20ZM19.07,30.363l1.567-1.579a.119.119,0,0,1,.08-.032H48.49a.1.1,0,0,1,.08.036l1.547,1.579a.115.115,0,0,1-.08.2H19.154A.119.119,0,0,1,19.07,30.363Zm22.206,1.611H27.959a.179.179,0,0,1-.168-.243l.375-.945a.178.178,0,0,1,.168-.112H40.9a.182.182,0,0,1,.167.112l.375.945A.176.176,0,0,1,41.276,31.974Zm11.605.435a.017.017,0,0,1-.016.016H16.418c-.008,0-.02-.008-.02-.016v-.259H52.877v.259Z",
    transform: "translate(-16.281 -9.8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangelogBasm);
export default __webpack_public_path__ + "static/media/changelog_basm.08732cc737166265dcb680c9339ec2f8.svg";
export { ForwardRef as ReactComponent };